function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.37516 34.2123C8.78367 35.0851 11.3794 35.5992 13.5212 36.9313",
  stroke: "currentColor",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.1081 18.2219C14.306 17.8551 16.4304 17.6072 18.5784 17.0701",
  stroke: "currentColor",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.63396 4.2794C3.53002 3.72899 4.65503 2.61502 5.69873 2.73543",
  stroke: "currentColor",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgKraftRight(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-kraft-right",
    width: 22,
    height: 39,
    viewBox: "0 0 22 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKraftRight);
export default __webpack_public_path__ + "static/media/kraft-right.639aa757.svg";
export { ForwardRef as ReactComponent };